import { EnumSortDirection } from '@hooks/useRequest';
import { TableCellProps, TableSortLabel } from '@material-ui/core';
import React from 'react';
import { TableHeaderCell } from './TableHeaderCell';
import { TableSortRowContext } from './TableSortRow';

export type TableSortCellProps = TableCellProps & {
    sortable?: boolean,
    fieldName: string
}

export function TableSortCell ({children, sortable, fieldName, ...props}: TableSortCellProps) {

    return (
        <TableSortRowContext.Consumer>
        {(sort) => {
            return (
                <TableHeaderCell>
                {
                    sortable !== false && sort !== undefined
                    ? (
                        <TableSortLabel
                            active={sort.isColumnSorted(fieldName)}
                            onClick={sort.handleSortFieldRequest(fieldName)}
                            direction={sort.isColumnSorted(fieldName) ? (sort.sortField?.direction !== EnumSortDirection.Desc ? "asc" : "desc") : "asc"}
                        >
                            { children }
                        </TableSortLabel>
                    )
                    : (
                        <React.Fragment>
                            { children }
                        </React.Fragment>
                    )
                }
                </TableHeaderCell>                
            )
        }}
        </TableSortRowContext.Consumer>
    )
}